/**
 * @name hasFocus
 *
 * @description Checks if the given element is focused
 *
 * @example
 * import { hasFocus } from '@workbench/core';
 *
 * hasFocus(myElementReference); // true
 */
const hasFocus = (element) => {
  return element.getRootNode().activeElement === element;
};

export { hasFocus as h };
